var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',_vm._b({staticClass:"body-2",attrs:{"type":_vm.type,"text":"","colored-border":"","border":"left"}},'v-alert',_vm.$attrs,false),[_c('div',{staticClass:"font-weight-bold body-1"},[_vm._v(_vm._s(_vm.title))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }